<template>
    <div class="c-tutorial-video">
        <div
            v-if="content.custom.field1"
            class="c-tutorial-video__iframe"
            v-html="content.custom.field1"
        />
        <div
            v-else
            class="c-tutorial-video__content"
        >
            <div
                v-if="!showVideo"
                class="c-tutorial-video__content__cover"
                :style="{ backgroundImage: `url(${imgSrc(content.image, 'main1')})` }"
            >
                <div :class="{'blur-bg': blurBackground}">
                    <div class="play-btn-container">
                        <img
                            src="@/assets/images/play.svg"
                            :alt="$t('button.alt.play')"
                            class="play-btn"
                            width="46"
                            height="46"
                            @click.prevent="showVideo = true"
                        >
                    </div>
                </div>
            </div>
            <div
                v-else
                class="c-tutorial-video__content__video"
            >
                <y-player :src="content.albums[0].link" />
            </div>
        </div>
    </div>
</template>

<script>
    import { YPlayer } from '@groot-components/all';

    export default {
        name      : 'TutorialVideoCard',
        components: { YPlayer },
        props     : {
            content       : Object,
            blurBackground: Boolean,
        },
        /**
         * @inheritDoc
         */
        data() {
            return {
                showVideo: false,
            };
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
